import React from 'react';
import Footer from "../components/Footer";
import Header from "../components/Header";

const Home = (props) => {
    return (
        <>
            <Header />
            <div style={{ backgroundColor: "#F8F9FA" }} id="home-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-5 my-auto">
                            <h2>Marsha Fitness<br/> All or Nothing</h2>
                            <p>Premium fitness apparel and accessories designed for performance, style, and confidence.</p>
                        </div>

                        <div className="col-12 col-md-7">
                            <img src="assets/images/gym.png" alt="logo" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid p-0" id="shop-selection">
                <div className="row no-gutters">
                    <div className="col-12 col-md-6">
                        <div id="gym-men">
                            <div>
                                <h5>MALE</h5>
                                <button className="btn btn-primary btn-cart btn-block" style={{borderColor: "white"}} onClick={() => props.history.push('/products/men')}>SHOW NOW</button>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div id="gym-female">
                            <div>
                                <h5>FEMALE</h5>
                                <button className="btn btn-primary btn-cart btn-block" style={{borderColor: "white"}} onClick={() => props.history.push('/products/women')}>SHOW NOW</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container" id="about">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src="assets/images/about.jpg" alt="about" />
                    </div>

                    <div className="col-12 col-md-6 my-auto">
                        <h5>Marsha Fitness — All or Nothing.</h5>
                        <p>We are more than a brand. Marsha Fitness is a wellness movement that connects fitness enthusiasts and empowers individuals to embrace an active and stylish lifestyle.</p>
                        <p>We pride ourselves by supplying high quality, functional and fashionable apparel, ensuring our community feels confident whether their giving their All or Nothing. </p>

                        <h6 id="tx-mission">OUR MISSION.</h6>
                        <p>To empower every individual and community member to look and feel their optimum best when doing All or Nothing.</p>
                    </div>
                </div>
            </div>

            <div className="container mb-5" id="product">
                <h5 id="tx-shop">SHOP best-sellers</h5>
                <h6 className="mb-4" style={{color: "#838383"}}>MEN / WOMEN</h6>
                <div className="row">
                    <div className="col-12 col-md-3" onClick={() => props.history.push('/product-detail/12345')}>
                        <img className="img-fluid mb-2" src="assets/images/sample-1.jpg" alt="" />
                        <h4>Basic Denise</h4>
                        <p>ZMW89.00</p>
                    </div>
                </div>
            </div>

            <div className="container" id="why-choose-us">

                <h3>WHY CHOOSE US</h3>

                <div className="row">
                    <div className="col-12 col-md-3 text-center">
                        <img src="assets/images/badge.png" alt="globe" height="70" />
                        <h5>Quality First</h5>
                        <p>Premium fabrics built for performance &amp; longevity.</p>
                    </div>

                    <div className="col-12 col-md-3 text-center">
                        <img src="assets/images/globe.png" alt="globe" height="70" />
                        <h5>Global Standards</h5>
                        <p>Designed to meet the needs of athletes and fitness enthusiasts everywhere</p>
                    </div>

                    <div className="col-12 col-md-3 text-center">
                        <img src="assets/images/bell.png" alt="globe" height="70" />
                        <h5>Style That Works</h5>
                        <p>Activewear that looks just as good outside the gym.</p>
                    </div>

                    <div className="col-12 col-md-3 text-center">
                        <img src="assets/images/team.png" alt="globe" height="70" />
                        <h5>Community Driven</h5>
                        <p>Join a brand that represents strength, unity, and lifestyle.</p>
                    </div>
                </div>
            </div>

            <div className="container-fluid" id="teamwork">
                <div className="container">
                    <div className="text-center w-100">
                        <h3>HARNESSING THE STRENGTH OF COMMUNITY, FITNESS STRIVES FOR A BETTER FUTURE FOR ALL</h3>
                        <p>Marsha Fitness isn’t just about what you wear — it’s about who you become. From community runs to fitness challenges, we’re building a culture of health, strength, and confidence.</p>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Home;
